import React from 'react'
import './Loader.css'

const loader = () => <div className="Loader"/>

export default React.memo(loader);